import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { HttpService } from './http/http.service';
import { SaleInvoiceRequest } from '../interface/product/salesinvoice/salesinvoice';
import { getTimezoneOffsetMinutes } from 'src/app/utils';

@Injectable({
  providedIn: 'root'
})
export class SaleDraftService {

  constructor(private _httpSaleInvoice: HttpService) { }
  get(id: number) {
    return firstValueFrom(this._httpSaleInvoice.get('/SaleDrafts/' + id))
  }
  getAll(): Promise<any> {
    return firstValueFrom(this._httpSaleInvoice.get('/SaleDrafts'));
  }
  create(data: SaleInvoiceRequest): Promise<any> {
    return firstValueFrom(this._httpSaleInvoice.post('/SaleDrafts', { ...data, timezoneOffsetMinutes: getTimezoneOffsetMinutes(data.date) }));
  }
  update(id:number,data: SaleInvoiceRequest): Promise<any> {
    return firstValueFrom(this._httpSaleInvoice.patch('/SaleDrafts/',id, data));
  }

  delete(id: number): Promise<any> {
    return firstValueFrom(this._httpSaleInvoice.delete('/SaleDrafts/', id));
  }
}
